module.exports = __webpack_public_path__ + "static/media/unibedfordshire.bda72542.png";